import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Flexed } from '../../styles/GlobalComponents';
import { Icon, IconFlipme } from '../../styles/Icons';
import { color } from '../../styles/GlobalStyles';
import { P1, P2, P3 } from '../../styles/FontStyles';
import { InputBackOffice } from '../../components/common/InputBackoffice';
import { ethers } from 'ethers';
import { ErrorToast, SuccessToast } from '../../components';
import { ConnectWallet } from './FlipMeBanner';

import Spinner from '../../components/common/Spinner';
import { useAppSelector } from '../../app/hooks';
import { settingsInit } from '../Settings/Settings.actions';
import axios from 'axios';
import { Withdraw2FARequired } from '../Earnings/Withdraw/Withdraw2FARequired';

interface Step1Props {
  isEarnings?: boolean;
  setStep: Dispatch<SetStateAction<number>>;
  walletAddress: string;
  setWalletAddress: Dispatch<SetStateAction<string>>;
}

export const Step1 = ({
  walletAddress,
  setWalletAddress,
  setStep
}: Step1Props) => {
  const [loadingCode, setLoadingCode] = useState(false);

  const { verificationStatus } = useAppSelector((state) => state.settings);

  const dispatch = useDispatch();

  const walletCheck = async () => {
    try {
      setLoadingCode(true);
      await axios.post(`/flipme/connect/wallet-check`, {
        walletAddress
      });

      setLoadingCode(false);

      if (!verificationStatus) {
        setStep(ConnectWallet.TWO_FA_REQUIRED);
      } else {
        setStep(ConnectWallet.SECOND_STEP);
      }
    } catch (error: any) {
      setLoadingCode(false);
      ErrorToast(error.response.data.error);
    }
  };

  const validateAddress = () => {
    if (!walletAddress) {
      ErrorToast('Please enter a wallet address.');
    }

    const isValid = ethers.utils.isAddress(walletAddress);

    if (isValid) {
      walletCheck();
    } else {
      ErrorToast('Invalid wallet address.');
    }
  };

  useEffect(() => {
    dispatch(settingsInit());
  }, [dispatch]);

  return (
    <>
      {loadingCode ? (
        <Spinner />
      ) : (
        <>
          {' '}
          <Flexed column center>
            <Icon>
              <IconFlipme />
            </Icon>

            <P2 color={color.colors.neutral500} caps bold mt='30' mb='30'>
              WHAT does Connecting to flipme wallet mean?
            </P2>
          </Flexed>
          <P2 mb='20' center bold>
            Connecting your Flip Me wallet allows you to securely withdraw your
            earned NFTs and available funds from our platform. Once connected,
            you can manage your assets directly in the Flip Me app and use your
            balance with your Flip Me card for real-world purchases. It’s the
            bridge between your rewards and real spending power.
          </P2>
          <P3 mb='8' mt='40' bold>
            Wallet address
          </P3>
          <InputBackOffice
            placeholder={'Enter wallet adress here'}
            style={{ marginBottom: 30 }}
            value={walletAddress}
            onChange={(e: string) => setWalletAddress(e)}
          />
          <Button
            disabled={walletAddress === ''}
            onClick={() => validateAddress()}>
            Connect Wallet
          </Button>
        </>
      )}
    </>
  );
};
